import script from "./UButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./UButton.vue?vue&type=script&setup=true&lang=ts"

import "./UButton.vue?vue&type=style&index=0&id=f9476cae&lang=scss"

const __exports__ = script;

export default __exports__